var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapse-menu',{staticClass:"menu",attrs:{"items":_vm.menuItems},scopedSlots:_vm._u([{key:_vm.MenuItems.OFFERS,fn:function(){return [_c('offer-menu-items')]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }